import React from 'react';
import { Link, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import Fetchable from '~/commons/components/util/Fetchable';
import Html from '~/commons/components/util/Html';
import Page from '../../layout/Page';
import Scroll from '../../layout/Scroll';
import StageIcon from '../../mods/StageIcon';

const PageStageQSets = () => {
  const { stage: url, difficulty } = useParams();
  const { i18n, t } = useTranslation();

  return (
    <Page>
      <Fetchable
        req={{
          url: '/api/stages',
          params: { filter: { url: `/${url}`, difficulty } },
        }}
      >
        {({ rows: stages }) => (
          <div className="container">
            <Scroll fillScreen>
              <div className="p-3">
                <div className="row justify-content-center">
                  <div className="col-10 col-md-9 ">
                    {stages[0]?.tip && (
                    <>
                      <h1 className="fw-bold">
                        {t('pg.game.stageTip')}
                        :
                      </h1>
                      <div className="pb-4">
                        <Html>{i18n.pickLng(stages[0].tip)}</Html>
                      </div>
                    </>
                    )}
                    <div className="row g-5">
                      {stages.map((s) => (
                        <Link
                          key={s._id}
                          to={s.refCode}
                          className="col-12 col-md-6 col-lg-4 col-xl-3"
                        >
                          <StageIcon
                            stage={s}
                            checked={s.answers?.length > 0}
                          />
                        </Link>
                      ))}
                    </div>
                  </div>

                </div>
              </div>

            </Scroll>
          </div>
        )}
      </Fetchable>
    </Page>
  );
};

export default PageStageQSets;
